/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from "react";

import {
  createCookie,
  deleteFromCookie,
  readCookie,
} from "../../../handleCookieData";
import BookmarkIcon from "../../../img/svg/Bookmark.svg";
import "./AddToMyList.css";
import { AddToMyListContext } from "../../../context/AddToMyListContext";

function AddToMyList(props) {
  const { daten, onListPage, callBack } = props;
  const [isChecked, setIsChecked] = useState(false);
  const { updateAddedBookmark, updateRemovedBookmark } = useContext(
    AddToMyListContext
  );

  useEffect(() => {
    setIsChecked(readCookie("list_cookie").indexOf(daten) !== -1);
  }, [daten]);

  function handleClick(ID) {
    if (isChecked) {
      deleteFromCookie("list_cookie", ID);
      setIsChecked(false);
      updateRemovedBookmark();
    } else {
      createCookie("list_cookie", ID, 30, 20);
      setIsChecked(true);
      updateAddedBookmark();
    }
    if (onListPage) {
      callBack();
    }
  }

  const checkedStyle = {
    filter: "invert() opacity(1)",
    transition: "0.4s ease",
    transform: "scale(1.1)",
  };

  return (
    <div className="meineListe">
      <input
        className="meineListeInputCheckbox"
        name="myListInput"
        defaultChecked={!!isChecked}
        type="checkbox"
      />
      <label>
        <button
          type="button"
          className="add-to-list-button"
          onClick={() => handleClick(daten)}
        >
          <img
            aria-label="Zu meiner Liste hinzufügen"
            alt="Zur Liste hinzufügen"
            className="meineListeIcon"
            style={isChecked ? checkedStyle : null}
            src={BookmarkIcon}
          />
        </button>
      </label>
    </div>
  );
}

export default AddToMyList;
